var map = {
	"./activity.scss": 3649,
	"./announcements.scss": 9664,
	"./application.scss": 5758,
	"./batches.scss": 9672,
	"./be.scss": 689,
	"./chatbot.scss": 807,
	"./clients.scss": 5160,
	"./clock.scss": 3538,
	"./documents.scss": 802,
	"./notifications.scss": 1472,
	"./orders.scss": 5653,
	"./packages.scss": 7085,
	"./products.scss": 8816,
	"./statistics.scss": 4203,
	"stylesheets/activity.scss": 3649,
	"stylesheets/announcements.scss": 9664,
	"stylesheets/application.scss": 5758,
	"stylesheets/batches.scss": 9672,
	"stylesheets/be.scss": 689,
	"stylesheets/chatbot.scss": 807,
	"stylesheets/clients.scss": 5160,
	"stylesheets/clock.scss": 3538,
	"stylesheets/documents.scss": 802,
	"stylesheets/notifications.scss": 1472,
	"stylesheets/orders.scss": 5653,
	"stylesheets/packages.scss": 7085,
	"stylesheets/products.scss": 8816,
	"stylesheets/statistics.scss": 4203
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8547;